var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 11C2 5.477 6.477 1 12 1C17.523 1 22 5.477 22 11V16.154C22 17.8 20.58 19 19 19H16V11H20C20 8.87827 19.1571 6.84344 17.6569 5.34315C16.1566 3.84285 14.1217 3 12 3C9.87827 3 7.84344 3.84285 6.34315 5.34315C4.84285 6.84344 4 8.87827 4 11H8V19H6.063C6.17387 19.4294 6.42431 19.8098 6.77495 20.0813C7.12558 20.3528 7.55652 20.5001 8 20.5H9.564C9.88 20.047 10.405 19.75 11 19.75H13C13.4641 19.75 13.9092 19.9344 14.2374 20.2626C14.5656 20.5908 14.75 21.0359 14.75 21.5C14.75 21.9641 14.5656 22.4092 14.2374 22.7374C13.9092 23.0656 13.4641 23.25 13 23.25H11C10.405 23.25 9.88 22.953 9.564 22.5H8C6.99791 22.5001 6.03228 22.1241 5.29415 21.4463C4.55602 20.7686 4.09918 19.8385 4.014 18.84C2.874 18.463 2 17.446 2 16.155V11Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.2a36a055a730616582e7d8ff3f131a1d.svg";
export { ForwardRef as ReactComponent };